<template>
  <div
    class="columns is-mobile is-multiline"
  >
    <template
      v-for="(land, index) in landbase"
      :key="'landbase' + index"
    >
      <div
        v-if="dataCategoryOptions[land] != null"
        class="column is-12-mobile is-12-tablet is-6-desktop"
      >
        <div class="card">
          <div
            v-if="dataCategoryOptions[land] != null"
            class="columns is-mobile is-multiline"
          >
            <div class="column is-12">
              <div class="protocol-header mt-6">
                <div class="h4" :class="{'is-blue': land === 'Wetland', 'is-darkGreen': land !== 'Wetland'}">
                  {{ land }} Protocols
                  <span
                    v-if="land==='Terrestrial'"
                    v-tooltip.right="{ html: true, content: $t('rawdata.terrestrialTooltips'), theme: 'info-tooltip' }"
                    class="svg info-orange-20"
                    style="cursor: help"
                  />
                  <span
                    v-if="land==='Wetland'"
                    v-tooltip.right="{ html: true, content: $t('rawdata.wetlandTooltips'), theme: 'info-tooltip' }"
                    class="svg info-orange-20"
                    style="cursor: help"
                  />
                </div>

                <DataSummaryViewVue :landbase="land" />
              </div>
              <!-- <div
              class="text-sm clickable"
              @click="() => { selectAllLandBase(false, land); }"
            >
              Clear Selection
            </div> -->
              <hr>
            </div>
            <div
              v-for="(data, dIndex) in dataType"
              :key="'protocol' + index + dIndex"
              class="column pt-0"
            >
              <checkbox-two-level
                :id="'category' + index + dIndex"
                :label="data + ' Variables'"
                :data-list="dataCategoryOptions[land][data].detail"
                :values="selectValues[land][data]"
                @update:check-result="(result) => { updateOption(land, data, result); }"
              />
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script setup lang="ts">

import { rawdataState } from '@/composables/state/rawdataApp';
import { landbase, dataType } from '@/config/rawdata.d';
import { Ref, onBeforeMount, ref, watch } from 'vue';
import CheckboxTwoLevel from '@/components/checkbox/CheckboxTwoLevel.vue';
import DataSummaryViewVue from './DataSummaryView.vue';

const {
  // state,
  dataCategoryOptions,
  resetDownloadState
} = rawdataState();

const selectValues:Ref<Record<string, Record<string, string[]>>> = ref({});
const updateSelection = () => {
  const obj:Record<string, Record<string, string[]>> = {};
  if (Object.keys(dataCategoryOptions).length === 0) {
    return;
  }
  landbase.forEach(land => {
    obj[land] = {};
    dataType.forEach(data => {
      obj[land][data] = dataCategoryOptions[land][data].detail.filter(x => x.checked).map(x => x.id + '');
    });
  });
  selectValues.value = { ...obj };
  resetDownloadState();
};

// const selectAll = (isSelectAll:boolean, optionList: any[]) => {
//   optionList.forEach(x => { x.checked = isSelectAll; });
// };

// const selectAllLandBase = (isSelectAll:boolean, land: string) => {
//   dataType.forEach(data => {
//     selectAll(isSelectAll, dataCategoryOptions[land][data].detail);
//   });
//   updateSelection();
// };
/* pass back all the current selected value, need to reassign to the orginal value */
const updateOption = (land: string, data:string, resultList: string[]) => {
  dataCategoryOptions[land][data].detail.forEach((single:Record<string, any>) => { single.checked = resultList.includes(single.id + ''); });
  updateSelection();
};
watch(() => dataCategoryOptions, () => {
  updateSelection();
}, { deep: true });

onBeforeMount(async () => {
  updateSelection();
});
</script>
<style scoped>
@import 'rawdata.scss';
.text-sm {
  font-size: 0.8rem;
}

.card {
  padding: 20px;
}
.protocol-header {
  display: flex;
  justify-content: space-between;
}
</style>
